// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__RBl_Q","content":"layout_content__Yu7ac","home_content":"layout_home_content__lJWJa"};